// extracted by mini-css-extract-plugin
module.exports = {"category-title":"category_category-title__3JNXB"};